<template>
  <div>
    <div id="TestPrepRenderer" @contextmenu.prevent>
      <!--- LEARN APP START --->
      <div class="TpAppScreen flex items-center justify-center overflow-hidden">
        <div class="TpAppParent">
          <div class="TpAppContainer">
            <slide-x-left-transition>
              <div v-if="appReady && !complete.active">
                <div class="TpBlockSelect mb-8">
                  <div class="flex items-center justify-between mb-2" v-if="assignmentData">
                    <h1 class="font-light text-4xl">{{ assignmentData.name }}</h1>
                    <img
                      v-if="assignmentData.thumbnail"
                      :src="assignmentData.thumbnail"
                      width="40"
                      height="40"
                      class="rounded shadow-md block mr-3"
                      draggable="false"
                      alt=""
                    />
                  </div>
                  <vs-progress :percent="progressBar" color="success" class="w-full LearnProgressBar" height="14"></vs-progress>
                  <div class="flex justify-between items-center">
                    <div class="flex justify-center items-center" v-if="quizData">
                      <lottie-animation
                        path="https://connect-cdn.intellectualpoint.com/assets/lotties/lf30_editor_nesztu9e.json"
                        class="w-5 h-5 mr-1"
                        :loop="true"
                      />
                      <p class="font-light">{{ quizData.questions.length }} Questions</p>
                    </div>
                    <div class="flex justify-center items-center">
                      <p class="font-light" v-if="timer.display">
                        <span v-if="timer.display.hours"
                          >{{ timer.display.hours }} {{ timer.display.hours === 1 ? 'Hour' : 'Hours' }} {{ timer.display.minutes }}
                          {{ timer.display.minutes === 1 ? 'Minute' : 'Minutes' }}</span
                        >
                        <span v-if="!timer.display.hours && timer.display.minutes"
                          >{{ timer.display.minutes }} {{ timer.display.minutes === 1 ? 'Minute' : 'Minutes' }}</span
                        >
                        <span v-if="!timer.display.hours && !timer.display.minutes && timer.display.seconds"
                          >{{ timer.display.seconds }} {{ timer.display.seconds === 1 ? 'Second' : 'Seconds' }}</span
                        >
                        Remaining
                      </p>
                      <p class="font-light" v-if="!timer.display && stopwatch.display">
                        <span v-if="stopwatch.display.hours"
                          >{{ stopwatch.display.hours }} {{ stopwatch.display.hours === 1 ? 'Hour' : 'Hours' }}</span
                        >
                        <span v-if="!stopwatch.display.hours && stopwatch.display.minutes"
                          >{{ stopwatch.display.minutes }} {{ stopwatch.display.minutes === 1 ? 'Minute' : 'Minutes' }}</span
                        >
                        <span v-if="!stopwatch.display.hours && !stopwatch.display.minutes && stopwatch.display.seconds"
                          >{{ stopwatch.display.seconds }} {{ stopwatch.display.seconds === 1 ? 'Second' : 'Seconds' }}</span
                        >
                        Elapsed
                      </p>
                      <lottie-animation
                        v-if="timer.display || stopwatch.display"
                        :path="
                          timer.display
                            ? 'https://connect-cdn.intellectualpoint.com/assets/lotties/lf30_editor_b9vegits.json'
                            : 'https://connect-cdn.intellectualpoint.com/assets/lotties/lf30_editor_ezlubx3m.json'
                        "
                        class="w-5 h-5 ml-1"
                        :loop="true"
                      />
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col relative w-3/4">
                    <slide-x-left-transition>
                      <div v-if="question.loaded">
                        <div class="flex items-center justify-between TpBlockSelect mb-4">
                          <div class="flex items-center justify-center gap-2">
                            <vx-tooltip :text="question.flagged ? 'Unflag Question' : 'Flag Question'" position="top" color="#fd4445">
                              <feather-icon
                                icon="FlagIcon"
                                class="cursor-pointer"
                                :svgClasses="`${question.flagged ? 'text-danger' : 'text-white'} h-8 w-8`"
                                @click="
                                  question.flagged = !question.flagged;
                                  saveQuestion();
                                "
                                id="flagBtn"
                              />
                            </vx-tooltip>
                            <p class="promptText mb-1">Question {{ question.index + 1 }}</p>
                          </div>
                        </div>
                        <div class="TpAllowSelect">
                          <template>
                            <div>
                              <h4 class="font-light mb-4" @contextmenu.prevent="$refs.textMenu.open">
                                <span
                                    v-for="(item, index) in parsedQuestion"
                                    :key="index"
                                >
                                  <!-- <p> {{ parsedQuestion }}</p> -->
                                  <template v-if="item.text === '\n'" >
                                      <br />
                                  </template>
                                  <template v-else>
                                      <span
                                          :class="item.isClickable ? 'text-primary font-bold cursor-pointer' : ''"
                                          @click="item.isClickable ? showImage(item.content) : null"
                                      >
                                          {{ item.text }}
                                          <feather-icon v-if="item.isClickable" icon="ExternalLinkIcon" svgClasses="h-4 w-4" class="" />
                                      </span>
                                </template>
                            </span>
                              </h4>
                            </div>
                          </template>
                        </div>
                        <vue-context ref="textMenu">
                          <li>
                            <a href="#" class="flex items-center text-sm" @click="visualChange('Highlight')">
                              <font-awesome-icon icon="fa-regular fa-highlighter" class="h-5 w-5" />
                              <span class="ml-2">Highlight</span>
                            </a>
                          </li>
                          <li>
                            <a href="#" class="flex items-center text-sm" @click="visualChange('Strikethrough')">
                              <font-awesome-icon icon="fa-regular fa-strikethrough" class="h-5 w-5" />
                              <span class="ml-2">Strikethrough</span>
                            </a>
                          </li>
                          <li v-if="visualChangeActive">
                            <a href="#" class="flex items-center text-sm" @click="visualChange('Reset')">
                              <font-awesome-icon icon="fa-regular fa-eraser" class="h-5 w-5" />
                              <span class="ml-2">Reset</span>
                            </a>
                          </li>
                        </vue-context>
                        <div class="TpBlockSelect" :key="question.key">
                          <p v-if="hasPrompt" class="mb-1 font-semibold">{{ question.data.meta.prompt }}</p>

                          <div class="mb-6">
                            <div v-if="question.data.type === 'multiple_choice' || question.data.type === 'select_choice'">
                              <div
                                v-for="(answer, index) in question.data.meta.options"
                                :key="index + ' - ' + answer.selected"
                                class="mb-2"
                              >
                                <vx-card
                                  class="multiChoiceCard cursor-pointer mb-2"
                                  :class="`${answer.selected ? 'cardSelected' : ''} ${
                                    showAnswer ? choiceOptionCorrect(answer, 'card') : ''
                                  }`"
                                  @click="choiceSelectOption(index)"
                                >
                                  <div class="flex items-center justify-center p-1 mb-3" v-if="false">
                                    <img draggable="false" :src="''" style="max-width: 12rem" alt="" />
                                  </div>
                                  <div class="flex items-center" :class="''">
                                    <font-awesome-icon class="h-5 w-5 mr-2" :icon="answerIcon(answer.icon, index)" />
                                    <span
                                      v-for="(item, index) in parsedAnswer(answer.text)"
                                      :key="index"
                                      :class="item.isClickable ? 'text-primary font-bold cursor-pointer' : ''"
                                      @click="item.isClickable ? showImage(item.content) : null"
                                    >
                                      {{ item.text }}
                                      <feather-icon v-if="item.isClickable" icon="ExternalLinkIcon" svgClasses="h-4 w-4" class="" />
                                    </span>
                                  </div>
                                </vx-card>
                                <h5 class="font-light mt-1" :class="`${choiceOptionCorrect(answer, 'color')}`" v-if="showAnswer">
                                  {{ choiceOptionCorrect(answer, 'text') }}
                                </h5>
                              </div>
                            </div>
                            <div v-if="question.data.type === 'text_answer' && question.data.meta">
                              <vs-input
                                v-model="question.data.meta.value"
                                class="w-1/2"
                                :placeholder="question.data.meta.sensitive ? 'Type Here... | Case-Sensitive' : 'Type Here...'"
                              />
                            </div>
                          </div>

                          <div style="overflow: visible !important;" class="vx-card border border-solid rounded-lg p-1" v-if="showAnswer">
                            <vs-collapse-item class="p-0">
                              <div slot="header" class="p-0">
                                <h3 class="font-light">Question Explanation</h3>
                              </div>
                              <template v-for="(item, index) in parsedExplanation">
                                <span v-if="item.text !== '\n'"
                                      :key="index"
                                      :class="item.isClickable ? 'text-primary font-bold cursor-pointer' : ''"
                                      @click="item.isClickable ? showImage(item.content) : null">
                                  {{ item.text }}
                                  <feather-icon v-if="item.isClickable" icon="ExternalLinkIcon" svgClasses="h-4 w-4" class="" />
                                </span>
                                                              <br v-else :key="index" />
                              </template>
                            </vs-collapse-item>
                          </div>
                        </div>
                      </div>
                    </slide-x-left-transition>

                    <slide-x-left-transition>
                      <div v-if="!question.loaded" class="absolute top-0 mt-2 simple-spinner">
                        <span></span>
                      </div>
                    </slide-x-left-transition>
                  </div>
                  <div class="vx-col w-1/4 TpBlockSelect">
                    <h3 class="font-light mb-2">Navigate Questions</h3>
                    <div class="grid grid-cols-2 gap-2 mb-6">
                      <vs-button
                        color="white"
                        icon-pack="feather"
                        icon="icon-arrow-left-circle"
                        class="font-bold text-white border border-solid border-white"
                        style="background: rgba(255, 255, 255, 0.1) !important"
                        @click="previousQuestion"
                        :disabled="!previousQuestionEnable"
                      >
                        Previous
                      </vs-button>
                      <vs-button
                        color="white"
                        icon-pack="feather"
                        icon="icon-arrow-right-circle"
                        class="font-bold text-white border border-solid border-white"
                        style="background: rgba(255, 255, 255, 0.1) !important"
                        @click="nextQuestion"
                        :disabled="!nextQuestionEnable"
                        icon-after
                      >
                        Next
                      </vs-button>
                    </div>

                    <h3 class="font-light mb-2">Quiz Progress</h3>
                    <div
                      class="flex items-center vx-card p-2 mb-2 border-solid border border-success"
                      style="background: rgb(12 220 98 / 30%)"
                    >
                      <feather-icon icon="CheckCircleIcon" svgClasses="h-6 w-6 mr-2 " />
                      <h5 class="mr-2">Questions Completed</h5>
                      <h5 class="font-light">{{ question.info.completed }}</h5>
                    </div>
                    <div
                      class="flex items-center vx-card p-2 mb-2 border-solid border border-warning"
                      style="background: rgb(255 159 67 / 30%)"
                    >
                      <feather-icon icon="AlertCircleIcon" svgClasses="h-6 w-6 mr-2 " />
                      <h5 class="mr-2">Questions Remaining</h5>
                      <h5 class="font-light">{{ question.info.remaining }}</h5>
                    </div>
                    <div
                      class="flex items-center mb-2 vx-card p-2 border-solid border border-danger"
                      style="background: rgb(253 68 69 / 30%)"
                    >
                      <feather-icon icon="FlagIcon" svgClasses="h-6 w-6 mr-2 " />
                      <h5 class="mr-2">Questions Flagged</h5>
                      <h5 class="font-light">{{ question.info.flagged }}</h5>
                    </div>
                    <div class="grid grid-cols-2 gap-2 mb-6">
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-file-text"
                        class="font-bold text-white border border-solid border-primary"
                        style="background: rgb(0 181 255 / 30%) !important"
                        @click="fetchSummary('popup')"
                        :disabled="summary.loading"
                        >Summary
                      </vs-button>
                      <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-fast-forward"
                        class="font-bold text-white border border-solid border-primary"
                        style="background: rgb(0 181 255 / 30%) !important"
                        @click="jump.popup = true"
                        >Jump
                      </vs-button>
                    </div>

                    <h3 class="font-light mb-2">Quiz Actions</h3>

                    <div class="grid grid-cols-1 gap-2 mb-6">
                      <!--- <vs-button
                        color="danger"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-arrow-left"
                        class="w-full font-bold"
                        @click="exitQuiz"
                        >Save & Exit
                      </vs-button>-->
                      <vs-button
                        v-if="quizData.type === 'study'"
                        color="#f39202"
                        icon-pack="feather"
                        :icon="showAnswer ? 'icon-eye-off' : 'icon-eye'"
                        class="font-bold text-white border border-solid"
                        style="background: rgba(245, 148, 3, 0.3) !important; border-color: #f39202"
                        @click="showAnswer = !showAnswer"
                        :disabled="summary.loading"
                        >{{ showAnswer ? 'Hide Answer' : 'Show Answer' }}
                      </vs-button>
                      <vs-button
                        color="success"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-check-circle"
                        class="w-full font-bold"
                        @click="submitQuiz"
                        :disabled="complete.active"
                        >Submit Quiz
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </slide-x-left-transition>

            <slide-x-left-transition>
              <div v-if="appReady && complete.active">
                <div class="vx-row">
                  <div class="w-1/4 pr-4">
                    <div class="flex justify-between items-center mb-4">
                      <div>
                        <h1 class="font-bold capitalize">
                          {{ assignmentData ? assignmentData.name : `${complete.data.quiz.type} Mode` }}
                        </h1>

                        <h5 v-if="assignmentData && complete.data.min_score !== null && complete.data.passed !== null"
                            :class="`font-bold rounded-full p-2 mt-4  ${complete.data.quiz.passed ? 'bg-success' : 'bg-danger'}`"
                            style="width: fit-content">
                          {{ complete.data.quiz.passed ? 'ASSIGNMENT PASSED' : 'ASSIGNMENT FAILED' }}
                        </h5>

                        <h5 v-else class="font-light">{{ complete.data.quiz.questions.length }} Questions</h5>
                      </div>

                      <radial-progress-bar
                        :diameter="90"
                        :completed-steps="complete.data.info.correct"
                        :total-steps="complete.data.info.total"
                        :animateSpeed="1100"
                        timingFunc="ease"
                        innerStrokeColor="#0000006b"
                        startColor="#0cdc62"
                        stopColor="#0cdc62"
                        :strokeWidth="7"
                        :innerStrokeWidth="7"
                      >
                        <h2 class="font-light">{{ complete.data.info.percent }}%</h2>
                      </radial-progress-bar>
                    </div>

                    <h1 class="font-light mb-2">Information</h1>
                    <div class="flex items-center mb-1">
                      <feather-icon icon="CalendarIcon" svgClasses="h-8 w-8 mr-2 text-success" />
                      <h3 class="mr-2">Date Taken</h3>
                      <h3 class="font-light">{{ completedAtDate }}</h3>
                    </div>
                    <div class="flex items-center mb-8">
                      <feather-icon icon="ClockIcon" svgClasses="h-8 w-8 mr-2 text-success" />
                      <h3 class="mr-2">Time Taken</h3>
                      <h3 class="font-light">{{ completedAtTime }}</h3>
                    </div>

                    <h1 class="font-light mb-2">Score</h1>
                    <div class="flex items-center mb-1">
                      <feather-icon icon="CheckCircleIcon" svgClasses="h-8 w-8 mr-2 text-success" />
                      <h3 class="mr-2">Questions Correct</h3>
                      <h3 class="font-light">{{ complete.data.info.correct }}</h3>
                    </div>
                    <div class="flex items-center mb-1">
                      <feather-icon icon="XCircleIcon" svgClasses="h-8 w-8 mr-2 text-danger" />
                      <h3 class="mr-2">Questions Incorrect</h3>
                      <h3 class="font-light">{{ complete.data.info.incorrect }}</h3>
                    </div>
                    <div class="flex items-center mb-8">
                      <feather-icon icon="InfoIcon" svgClasses="h-8 w-8 mr-2 " style="color: #0059ff" />
                      <h3 class="mr-2">Questions Blank</h3>
                      <h3 class="font-light">{{ complete.data.info.blank }}</h3>
                    </div>

                    <div class="mb-8" v-if="complete.data.info.time_spent_full || complete.data.info.time_spent_idle">
                      <h1 class="font-light mb-2">Quiz Statistics</h1>
                      <div class="flex items-center mb-1" v-if="complete.data.info.time_spent_full">
                        <font-awesome-icon icon="fa-regular fa-clock" class="h-8 w-8 mr-2 text-success" />
                        <h3 class="font-light">{{ humanizeSeconds(complete.data.info.time_spent_full) }} Total Time</h3>
                      </div>
                      <div class="flex items-center mb-1" v-if="complete.data.info.time_spent_idle">
                        <font-awesome-icon icon="fa-regular fa-house-person-leave" class="h-8 w-8 mr-2 text-danger" />
                        <h3 class="font-light">{{ humanizeSeconds(complete.data.info.time_spent_idle) }} Idling</h3>
                      </div>
                    </div>

                    <div class="mb-6" v-if="complete.data.info.time_avg_question_full">
                      <h1 class="font-light mb-2">Question Statistics</h1>
                      <div class="flex items-center mb-6">
                        <font-awesome-icon icon="fa-regular fa-chart-bar" class="h-8 w-8 mr-2 text-success" />
                        <h3 class="font-light">{{ humanizeSeconds(complete.data.info.time_avg_question_full) }} Avg Per Question</h3>
                      </div>
                    </div>

                    <!--- <vs-button class="font-bold w-full mb-2" type="gradient" color="success" icon-pack="feather"
                               icon="icon-file-text">
                      View Report Card
                    </vs-button> --->

                    <vs-button
                      class="font-bold w-full"
                      type="gradient"
                      color="danger"
                      icon-pack="feather"
                      icon="icon-arrow-left-circle"
                      @click="exitQuiz()"
                    >
                      Exit Quiz
                    </vs-button>
                  </div>
                  <div class="w-3/4 pl-4">
                    <div class="mb-4 flex justify-between items-center">
                      <h1 class="font-bold">{{ complete.summary ? 'Quiz Summary' : 'Review Question' }}</h1>
                      <p>{{ complete.summary ? "If you don't see question buttons beneath here, simply refresh the page, don't worry you wont lose your progress." : '' }}</p>
                      <div class="flex items-center gap-3" v-if="!complete.summary">
                        <vs-button
                          color="primary"
                          type="gradient"
                          icon-pack="feather"
                          icon="icon-file-text"
                          class="font-bold"
                          @click="summaryCompleteShow"
                          >Summary
                        </vs-button>
                        <vs-button
                          color="white"
                          icon-pack="feather"
                          icon="icon-arrow-left-circle"
                          class="font-bold text-white border border-solid border-white"
                          style="background: rgba(255, 255, 255, 0.1) !important"
                          @click="previousQuestion"
                          :disabled="!previousQuestionEnable"
                        >
                          Previous
                        </vs-button>
                        <vs-button
                          color="white"
                          icon-pack="feather"
                          icon="icon-arrow-right-circle"
                          class="font-bold text-white border border-solid border-white"
                          style="background: rgba(255, 255, 255, 0.1) !important"
                          @click="nextQuestion"
                          :disabled="!nextQuestionEnable"
                          icon-after
                        >
                          Next
                        </vs-button>
                      </div>
                    </div>

                    <div class="relative">
                      <slide-x-left-transition>
                        <div v-if="complete.summary && !complete.question && summary.data">
                          <h5 class="font-light mb-2">{{ summaryQuestionDescription | capitalize }}</h5>
                          <div class="grid grid-cols-5 gap-4 mb-4">
                            <div
                              v-for="item in summary.data"
                              :key="item.index"
                              @click="summaryCompleteQuestion(item.index)"
                              :style="`background: ${summaryQuestionBackground(item, 'complete')}`"
                              class="flex justify-center items-center rounded-lg p-4 cursor-pointer"
                            >
                              <h1 class="font-bold">{{ item.index + 1 }}</h1>
                            </div>
                          </div>
                          <div class="flex justify-between items-center">
                            <vs-button
                              color="primary"
                              type="gradient"
                              icon-pack="feather"
                              icon="icon-fast-forward"
                              class="font-bold"
                              @click="jump.popup = true"
                              >Jump
                            </vs-button>
                            <vs-pagination :total="summary.pages" v-model="summary.active" />
                          </div>
                        </div>
                      </slide-x-left-transition>

                      <slide-x-left-transition>
                        <div v-if="!complete.summary && complete.question && question.loaded">
                          <div class="flex items-center justify-between TpBlockSelect mb-2">
                            <div>
                              <div class="flex items-center">
                                <feather-icon
                                  v-if="question.attempt.correct && question.completed"
                                  :icon="'CheckCircleIcon'"
                                  svg-classes="h-10 w-10 text-success mr-2"
                                />
                                <feather-icon
                                  v-if="!question.attempt.correct && question.completed"
                                  :icon="'XCircleIcon'"
                                  svg-classes="h-10 w-10 text-danger mr-2"
                                />
                                <feather-icon v-if="!question.completed" :icon="'InfoIcon'" svg-classes="h-10 w-10 text-warning mr-2" />
                                <p
                                  class="promptText"
                                  :class="`${question.attempt.correct && question.completed ? 'text-success' : 'text-danger'}
                                   ${!question.completed ? 'text-warning' : ''}`"
                                >
                                  Question {{ question.index + 1 }}
                                </p>
                              </div>
                              <h5 v-if="!question.completed" class="text-warning font-light mb-2">This question was left blank.</h5>
                            </div>
                          </div>
                          <div class="TpAllowSelect">
                            <h4 class="font-light mb-4">
                              <span
                                  v-for="(item, index) in parsedQuestion"
                                  :key="index"
                              >
                                  <template v-if="item.text === '\n'">
                                      <br />
                                  </template>
                                  <template v-else>
                                      <span
                                          :class="item.isClickable ? 'text-primary font-bold cursor-pointer' : ''"
                                          @click="item.isClickable ? showImage(item.content) : null"
                                      >
                                          {{ item.text }}
                                          <feather-icon v-if="item.isClickable" icon="ExternalLinkIcon" svgClasses="h-4 w-4" class="" />
                                      </span>
                                </template>
                            </span>
                            </h4>
                          </div>

                          <div class="TpBlockSelect" :key="question.key">
                            <p v-if="hasPrompt" class="mb-1 font-semibold">{{ question.data.meta.prompt }}</p>

                            <div class="mb-6">
                              <div v-if="question.data.type === 'multiple_choice' || question.data.type === 'select_choice'">
                                <div
                                  :key="index + ' - ' + answer.selected"
                                  class="mb-2"
                                  v-for="(answer, index) in question.data.meta.options"
                                >
                                  <vx-card class="multiChoiceCard cursor-pointer" :class="`${choiceOptionCorrect(answer, 'card')}`">
                                    <div class="flex items-center justify-center p-1 mb-3" v-if="false">
                                      <img draggable="false" :src="''" style="max-width: 12rem" alt="" />
                                    </div>
                                    <div class="flex items-center" :class="''">
                                      <font-awesome-icon class="h-5 w-5 mr-2" :icon="answerIcon(answer.icon, index)" />
                                      <span
                                        v-for="(item, index) in parsedAnswer(answer.text)"
                                        :key="index"
                                        :class="item.isClickable ? 'text-primary font-bold cursor-pointer' : ''"
                                        @click="item.isClickable ? showImage(item.content) : null"
                                      >
                                        {{ item.text }}
                                        <feather-icon v-if="item.isClickable" icon="ExternalLinkIcon" svgClasses="h-4 w-4" class="" />
                                      </span>
                                    </div>
                                  </vx-card>
                                  <h5 class="font-light mt-1" :class="`${choiceOptionCorrect(answer, 'color')}`">
                                    {{ choiceOptionCorrect(answer, 'text') }}
                                  </h5>
                                </div>
                              </div>

                              <div v-if="question.data.type === 'text_answer' && question.data.meta">
                                <vs-input
                                  v-model="question.data.meta.value"
                                  class="w-1/2"
                                  readonly
                                  :placeholder="question.data.meta.sensitive ? 'Type Here... | Case-Sensitive' : 'Type Here...'"
                                />
                              </div>
                            </div>

                            <div style="overflow: visible !important;" class="vx-card border border-solid rounded-lg p-1">
                              <vs-collapse-item class="p-0">
                                <div slot="header" class="p-0">
                                  <h3 class="font-light">Question Explanation</h3>
                                </div>
                                <template v-for="(item, index) in parsedExplanation">
                                  <span v-if="item.text !== '\n'"
                                        :key="index"
                                        :class="item.isClickable ? 'text-primary font-bold cursor-pointer' : ''"
                                        @click="item.isClickable ? showImage(item.content) : null">
                                    {{ item.text }}
                                    <feather-icon v-if="item.isClickable" icon="ExternalLinkIcon" svgClasses="h-4 w-4" class="" />
                                  </span>
                                                                  <br v-else :key="index" />
                                </template>
                              </vs-collapse-item>
                            </div>
                          </div>
                        </div>
                      </slide-x-left-transition>

                      <slide-x-left-transition>
                        <div v-if="!question.loaded || !summary.loaded" class="absolute top-0 mt-8 simple-spinner">
                          <span></span>
                        </div>
                      </slide-x-left-transition>
                    </div>
                  </div>
                </div>
              </div>
            </slide-x-left-transition>

            <div v-if="!appReady" class="absolute top-0 mt-2 simple-spinner">
              <span></span>
            </div>
          </div>
        </div>
      </div>

      <!--- POPUP MODALS --->
      <vs-popup :active.sync="settings.popup" class="pb-3" title="Settings">
        <div class="p-2 pt-0">
          <h1 class="mb-5">ExamEdge Settings</h1>

          <div class="flex p-3 rounded-lg vx-card">
            <vs-switch color="success" v-model="settings.keyboardShortcuts" class="mr-3" />
            <h4>Keyboard Shortcuts</h4>
          </div>
        </div>
      </vs-popup>

      <vs-popup :active.sync="timer.popup" class="pb-3" title="Start Timer">
        <div class="p-2 pt-0">
          <h4 class="mb-2">Select Timer Length</h4>
          <div class="flex items-center mb-8">
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="15"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              >15 Min
            </vs-radio>
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="30"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              >30 Min
            </vs-radio>
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="45"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              >45 Min
            </vs-radio>
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="60"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              >1 Hour
            </vs-radio>
            <vs-radio
              v-model="timer.length"
              color="white"
              :vs-value="120"
              vs-name="timer"
              class="mr-3 p-2 font-bold rounded-lg bg-primary-gradient"
              >2 Hours
            </vs-radio>
          </div>
          <h4 class="mb-1">Enter Custom Time (In Minutes)</h4>
          <div class="flex items-center mb-8">
            <vs-input-number
              class="bg-primary-gradient font-bold"
              :min="1"
              :max="720"
              :max-decimal="0"
              size="large"
              v-model="timer.length"
            />
          </div>
          <div class="flex items-center">
            <vs-button color="primary" icon-pack="feather" icon="icon-clock" class="font-bold mr-2" type="gradient" @click="timerStart"
              >Start Timer
            </vs-button>
            <vs-button
              v-if="timer.display"
              color="danger"
              icon-pack="feather"
              icon="icon-clock"
              class="font-bold"
              type="gradient"
              @click="timerEnd"
              >End Timer
            </vs-button>
          </div>
        </div>
      </vs-popup>

      <vs-popup :active.sync="summary.popup" class="pb-3" title="Quiz Summary">
        <div class="p-2 pt-1">
          <h5 class="font-light mb-2">Filter Questions</h5>
          <div class="flex items-center mb-4">
            <vs-radio
              v-model="summary.filter"
              color="white"
              vs-value="all"
              vs-name="filter"
              class="mr-3 p-2 font-bold rounded-lg"
              style="background: #0059ff"
              >All Questions
            </vs-radio>
            <vs-radio
              v-if="question.info.completed"
              v-model="summary.filter"
              color="white"
              vs-value="answered"
              vs-name="filter"
              class="mr-3 p-2 font-bold rounded-lg"
              style="background: #0cdc62"
              >Answered
            </vs-radio>
            <vs-radio
              v-if="question.info.remaining"
              v-model="summary.filter"
              color="white"
              vs-value="unanswered"
              vs-name="filter"
              class="mr-3 p-2 font-bold rounded-lg"
              style="background: #ff9f43"
              >Unanswered
            </vs-radio>
            <vs-radio
              v-if="question.info.flagged"
              v-model="summary.filter"
              color="white"
              vs-value="flagged"
              vs-name="filter"
              class="mr-3 p-2 font-bold rounded-lg"
              style="background: #fd4445"
              >Flagged
            </vs-radio>
          </div>

          <h5 class="font-light mb-2">{{ summaryQuestionDescription | capitalize }}</h5>
          <div class="grid grid-cols-5 gap-4 mb-4">
            <div
              v-for="item in summary.data"
              :key="item.index"
              @click="
                saveQuestion(item.index);
                summary.popup = false;
              "
              :style="`background: ${summaryQuestionBackground(item, 'popup')}`"
              class="flex justify-center items-center rounded-lg p-4 cursor-pointer"
            >
              <h1 class="font-bold">{{ item.index + 1 }}</h1>
            </div>
          </div>

          <vs-pagination :total="summary.pages" v-model="summary.active" />
        </div>
      </vs-popup>

      <vs-popup :active.sync="jump.popup" title="Jump To Question">
        <div class="p-2 popup-input" v-if="quizData">
          <div class="flex items-center mb-4">
            <feather-icon icon="InfoIcon" svgClasses="h-8 w-8 mr-1" />
            <h3 class="ml-1">Enter A Question Number Between 1 and {{ quizData.questions.length }}</h3>
          </div>

          <div class="mb-5">
            <vs-input
              v-model="jump.value"
              class="w-full"
              placeholder="Question Number"
              v-validate="`between:1,${quizData.questions.length}`"
              name="Jump"
            />
            <span class="text-danger text-sm" v-show="errors.has('Jump')">{{ errors.first('Jump') }}</span>
          </div>

          <vs-button
            color="primary"
            type="gradient"
            icon-pack="feather"
            icon="icon-fast-forward"
            :disabled="!jump.value || errors.has('Jump')"
            @click="
              summaryCompleteQuestion(parseInt(jump.value) - 1, true);
              jump.value = null;
              jump.popup = false;
            "
            >Jump To Question
          </vs-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import LottieAnimation from '../../../../components/lottie/LottieAnimation'
import { useStopwatch, useTimer } from 'vue-timer-hook'
import RadialProgressBar from 'vue-radial-progress'
import { VueContext } from 'vue-context'

export default {
  data () {
    return {
      appReady: false,

      showAnswer: false,

      complete: {
        active: false,
        question: false,
        summary: true,
        transition: null,
        data: null
      },

      enableEditMode: false,

      jump: {
        popup: false,
        value: null
      },

      quizId: null,
      quizData: null,

      question: {
        loaded: false,
        completed: false,
        flagged: false,
        index: 0,
        key: 0,
        attempt: null,
        data: null,
        info: {
          completed: 0,
          remaining: 0,
          flagged: 0
        }
      },

      settings: {
        popup: false,
        defaultColor: '#0059ff',
        keyboardShortcuts: true
      },

      assignmentData: null,

      summary: {
        loaded: false,
        loading: false,
        popup: false,
        filter: 'all',
        data: null,
        active: 1,
        count: 0,
        pages: 0
      },

      stopwatch: {
        display: null,
        question: {
          solving: null,
          full: null
        }
      },

      timer: {
        display: null
      },

      visualChangeActive: false
    }
  },
  components: {
    LottieAnimation,
    RadialProgressBar,
    useTimer,
    useStopwatch,
    VueContext
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    },
    completedAtDate () {
      if (this.complete.data.quiz.completed_at) return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format(
        this.complete.data.quiz.completed_at,
      )
      return ''
    },
    completedAtTime () {
      if (this.complete.data.quiz.completed_at) return new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: 'numeric' }).format(this.complete.data.quiz.completed_at)
      return ''
    },
    hasPrompt () {
      if (this.question.data && this.question.data.meta && this.question.data.meta.prompt) return this.question.data.meta.prompt
      return false
    },
    progressBar () {
      if (this.question.info) return this.question.info.percent
      return 0
    },
    parsedQuestion() {
      if (this.question.data.question === null) return [{ isClickable: false, text: 'No Question', content: null }];

      const imgPattern = /\(#IMG\s*{\s*text:\s*"([^"]*)",\s*image:\s*"([^"]*)"}\)/g;
      const newlinePattern = /\(#BR\)/g;
      const actualNewlinePattern = /\n/g;  // Pattern to match actual newlines
      const parts = [];
      let lastIndex = 0;

      while (lastIndex < this.question.data.question.length) {
        imgPattern.lastIndex = lastIndex;
        newlinePattern.lastIndex = lastIndex;
        actualNewlinePattern.lastIndex = lastIndex;

        const imgMatch = imgPattern.exec(this.question.data.question);
        const newlineMatch = newlinePattern.exec(this.question.data.question);
        const actualNewlineMatch = actualNewlinePattern.exec(this.question.data.question);

        let nextMatch;

        if (imgMatch && (!newlineMatch || imgMatch.index < newlineMatch.index) && (!actualNewlineMatch || imgMatch.index < actualNewlineMatch.index)) {
          nextMatch = imgMatch;
          parts.push({
            isClickable: false,
            text: this.question.data.question.substring(lastIndex, nextMatch.index),
            content: null
          });
          parts.push({
            isClickable: true,
            text: nextMatch[1],
            content: nextMatch[2]
          });
          lastIndex = imgPattern.lastIndex;
        } else if (newlineMatch && (!actualNewlineMatch || newlineMatch.index < actualNewlineMatch.index)) {
          nextMatch = newlineMatch;
          parts.push({
            isClickable: false,
            text: this.question.data.question.substring(lastIndex, nextMatch.index),
            content: null
          });
          parts.push({
            isClickable: false,
            text: '\n',
            content: null
          });
          lastIndex = newlinePattern.lastIndex;
        } else if (actualNewlineMatch) {
          nextMatch = actualNewlineMatch;
          parts.push({
            isClickable: false,
            text: this.question.data.question.substring(lastIndex, nextMatch.index),
            content: null
          });
          parts.push({
            isClickable: false,
            text: '\n',
            content: null
          });
          lastIndex = actualNewlinePattern.lastIndex;
        } else {
          // No more matches
          parts.push({
            isClickable: false,
            text: this.question.data.question.substring(lastIndex),
            content: null
          });
          break;
        }
      }

      return parts;
    },
    parsedExplanation() {
      if (this.question.data.explanation_text === null) return [{ isClickable: false, text: 'No Explanation', content: null }];

      const imgPattern = /\(#IMG\s*{\s*text:\s*"([^"]*)",\s*image:\s*"([^"]*)"}\)/g;
      const newlinePattern = /\(#BR\)/g;
      const actualNewlinePattern = /\n/g;  // Pattern to match actual newlines
      const parts = [];
      let lastIndex = 0;

      while (lastIndex < this.question.data.explanation_text.length) {
        imgPattern.lastIndex = lastIndex;
        newlinePattern.lastIndex = lastIndex;
        actualNewlinePattern.lastIndex = lastIndex;

        const imgMatch = imgPattern.exec(this.question.data.explanation_text);
        const newlineMatch = newlinePattern.exec(this.question.data.explanation_text);
        const actualNewlineMatch = actualNewlinePattern.exec(this.question.data.explanation_text);

        let nextMatch;

        if (imgMatch && (!newlineMatch || imgMatch.index < newlineMatch.index) && (!actualNewlineMatch || imgMatch.index < actualNewlineMatch.index)) {
          nextMatch = imgMatch;
          parts.push({
            isClickable: false,
            text: this.question.data.explanation_text.substring(lastIndex, nextMatch.index),
            content: null
          });
          parts.push({
            isClickable: true,
            text: nextMatch[1],
            content: nextMatch[2]
          });
          lastIndex = imgPattern.lastIndex;
        } else if (newlineMatch && (!actualNewlineMatch || newlineMatch.index < actualNewlineMatch.index)) {
          nextMatch = newlineMatch;
          parts.push({
            isClickable: false,
            text: this.question.data.explanation_text.substring(lastIndex, nextMatch.index),
            content: null
          });
          parts.push({
            isClickable: false,
            text: '\n',
            content: null
          });
          lastIndex = newlinePattern.lastIndex;
        } else if (actualNewlineMatch) {
          nextMatch = actualNewlineMatch;
          parts.push({
            isClickable: false,
            text: this.question.data.explanation_text.substring(lastIndex, nextMatch.index),
            content: null
          });
          parts.push({
            isClickable: false,
            text: '\n',
            content: null
          });
          lastIndex = actualNewlinePattern.lastIndex;
        } else {
          // No more matches
          parts.push({
            isClickable: false,
            text: this.question.data.explanation_text.substring(lastIndex),
            content: null
          });
          break;
        }
      }

      return parts;
    },
    nextQuestionEnable () {
      if (this.quizData) return this.question.index + 1 < this.quizData.questions.length
      return false
    },
    previousQuestionEnable () {
      return this.question.index > 0
    },
    summaryQuestionDescription () {
      if (this.summary.data && this.summary.count) return `Showing ${this.summary.count} Question${this.summary.count === 1 ? '' : 's'}`
      if (this.summary.filter !== 'all') return 'No Questions Found In Selected Filter'
      return 'No Questions Found'
    }
  },
  watch: {
    'settings': {
      handler () {
        localStorage.setItem('testPrepSettings', JSON.stringify(this.settings))
      },
      deep: true
    },
    'summary.active' () {
      this.fetchSummary()
    },
    'summary.filter' () {
      this.fetchSummary()
    },
    'timer.display.minutes': {
      handler () {
        if (this.timer.display.minutes === 5) {
          this.$vs.dialog({
            color: 'danger',
            title: '5 Minutes Remaining',
            text: 'You have 5 Minutes left to complete your quiz.',
            acceptText: 'Dismiss'
          })
        }
        if (this.timer.display.minutes === 1) {
          this.$vs.dialog({
            color: 'danger',
            title: '1 Minute Remaining',
            text: 'You have 1 Minute left to complete your quiz.',
            acceptText: 'Dismiss'
          })
        }
      }
    },
    'timer.display.isExpired': {
      handler () {
        if (this.timer.display.isExpired) {
          this.$vs.dialog({
            color: 'danger',
            title: 'Times Up!',
            text: 'You have ran out of time to complete your quiz.',
            acceptText: 'View Results'
          })

          this.confirmSubmitQuiz()
        }
      }
    }
  },
  methods: {
    alertInfo (title, msg) {
      this.$vs.notify({
        color: 'primary',
        title,
        text: msg,
        icon: 'feather',
        iconPack: 'icon-info'
      })
    },
    answerIcon (val, index) {
      if (val !== 'default') return val
      return `fa-regular fa-circle-${String.fromCharCode(97 + index)}`
    },
    checkQuestionComplete () {
      if (this.question.data.type === 'text_answer') {
        if (this.question.data.meta.value !== '') return (this.question.completed = true)
        return (this.question.completed = false)
      }
    },
    choiceOptionCorrect (option, type) {
      if (!this.question) return ''
      if (!this.question.data.meta) return ''
      if (!this.question.data.meta.answers) return ''
      const answer = this.question.data.meta.answers.find((o) => o.text === option.text)

      let response
      if (option.selected === true && option.selected === answer.correct) response = 'correct'
      if (option.selected === false && answer.correct === true) response = 'fixed'
      if (option.selected === true && option.selected !== answer.correct) response = 'selected'

      if (type === 'card') {
        if (response === 'correct') return 'cardSuccess'
        if (response === 'fixed') return 'cardSelected'
        if (response === 'selected') return 'cardDanger'
        return ''
      }

      if (type === 'color') {
        if (response === 'correct') return 'text-success'
        if (response === 'fixed') return 'text-primary'
        if (response === 'selected') return 'text-danger'
      }

      if (type === 'text') {
        if (response === 'correct') return 'This answer selected is correct.'
        if (response === 'fixed') return 'This is the correct answer.'
        if (response === 'selected') return 'This answer selected is not correct.'
      }

      return ''
    },
    choiceSelectOption (index) {
      if (this.question.data.type !== 'select_choice') {
        this.question.data.meta.options.forEach((answer, index) => {
          this.question.data.meta.options[index].selected = false
        })
      }

      this.question.data.meta.options[index].selected = !this.question.data.meta.options[index].selected

      let complete = false
      this.question.data.meta.options.forEach((answer) => {
        if (answer.selected === true) complete = true
      })
      this.question.completed = complete

      this.question.key++
    },
    confirmExitQuiz () {
      this.$router.push('/examedge/select')
    },
    exitQuiz () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Exit Current Quiz',
        text: 'Are you sure you want to return to the ExamEdge dashboard?',
        accept: this.confirmExitQuiz,
        acceptText: 'Leave'
      })
    },
    fetchInit () {
      this.$http
        .post(`app/testprep/${this.quizId}/start`)
        .then((response) => {
          if (response.status === 200) {
            this.quizData = response.data.data.quiz
            this.assignmentData = response.data.data.assignment

            if (response.data.data.expired) {
              this.$vs.notify({
                title: 'Quiz Ran Out Of Time',
                text: 'You have run out of time to complete this quiz.',
                icon: 'feather',
                iconPack: 'icon-clock',
                color: 'warning',
                position: 'top-right'
              })
            }

            if (response.data.data.completed) {
              this.complete.active = true
              this.fetchReport()
              return
            }

            if (response.data.data.quiz.time_expiry) {
              this.timerStart(response.data.data.quiz.time_expiry)
            }

            this.appReady = true
            this.stopwatchStart()
            this.fetchQuestion(response.data.data.index)
          }
        })
        .catch(() => {})
    },
    fetchQuestion (index) {
      this.question.loaded = false
      this.$http
        .post(`app/testprep/${this.quizId}/question`, {
          index,
          viewed: true
        })
        .then((response) => {
          if (response.status === 200) {
            this.question.index = index

            this.question.data = response.data.data.question

            this.question.attempt = response.data.data.attempt
            this.question.completed = this.question.attempt.completed
            this.question.flagged = this.question.attempt.flagged

            if (this.question.attempt.meta) {
              Object.keys(this.question.attempt.meta).forEach((key) => {
                if (this.question.data.meta[key] !== undefined) {
                  this.question.data.meta[key] = this.question.attempt.meta[key]
                }
              })
            }

            this.question.info = response.data.data.info

            this.stopwatch.question.full = useStopwatch(true)
            this.stopwatch.question.solving = useStopwatch(true)

            this.question.loaded = true
          }
        })
        .catch(() => {})
    },
    fetchReport () {
      this.$http
        .post(`app/testprep/${this.quizId}/report`)
        .then((response) => {
          this.fetchQuestion(0)
          this.fetchSummary('complete')
          this.complete.data = response.data.data
          this.appReady = true
        })
        .catch(() => {})
    },
    fetchSummary (type = null) {
      if (this.summary.loading) return
      this.summary.loaded = false
      if (type) this.summary.loading = true
      this.$http
        .post(`app/testprep/${this.quizId}/summary?amount=30&page=${this.summary.active}&filter=${this.summary.filter}`)
        .then((response) => {
          if (response.status === 200) {
            this.summary.data = response.data.data.summary
            this.summary.count = response.data.data.count
            this.summary.pages = response.data.data.pages
            this.summary.loaded = true
            if (type) this.summary.loading = false
            if (type === 'complete') this.complete.summary = true
            if (type === 'popup') this.summary.popup = true
          }
        })
        .catch(() => {})
    },
    getSeconds (stopwatch) {
      let seconds = 0
      if (stopwatch.seconds) seconds = seconds + stopwatch.seconds
      if (stopwatch.minutes) seconds = (seconds + stopwatch.minutes) * 60
      if (stopwatch.hours) seconds = (seconds + stopwatch.hours) * 3600
      if (stopwatch.days) seconds = (seconds + stopwatch.days) * 86400
      return seconds
    },
    humanizeSeconds (time) {
      let result = ''
      if (time) {
        if ((result = Math.round(time / (60 * 60 * 24 * 30 * 12))) > 0) {
          //year
          result = result === 1 ? `${result} Year` : `${result} Years`
        } else if ((result = Math.round(time / (60 * 60 * 24 * 30))) > 0) {
          //months
          result = result === 1 ? `${result} Month` : `${result} Months`
        } else if ((result = Math.round(time / (60 * 60 * 24))) > 0) {
          //days
          result = result === 1 ? `${result} Day` : `${result} Days`
        } else if ((result = Math.round(time / (60 * 60))) > 0) {
          //Hours
          result = result === 1 ? `${result} Hours` : `${result} Hours`
        } else if ((result = Math.round(time / 60)) > 0) {
          //minute
          result = result === 1 ? `${result} Minute` : `${result} Minutes`
        } else {
          result = `${time} Seconds`
        }
      }
      return result
    },
    keyPressed (e) {
      if (this.settings.keyboardShortcuts && !this.searchTermPopup && !this.jumpTermPopup && !this.filterPopup && !this.enableEditMode) {
        if (e.code === 'ArrowRight') {
          this.nextQuestion()
        }
        if (e.code === 'ArrowLeft') {
          this.previousQuestion()
        }
      }
    },
    nextQuestion () {
      this.showAnswer = false
      if (!this.nextQuestionEnable) return
      this.saveQuestion(this.question.index + 1, true)
    },
    parsedAnswer (text) {
      if (text === null) return [{ isClickable: false, text: 'No Answer', content: null }]
      const pattern = /\(#IMG\s*{\s*text:\s*"([^"]*)",\s*image:\s*"([^"]*)"}\)/g
      const parts = []
      let match
      let lastIndex = 0
      while ((match = pattern.exec(text)) !== null) {
        parts.push({
          isClickable: false,
          text: text.substring(lastIndex, match.index),
          content: null
        })
        parts.push({
          isClickable: true,
          text: match[1],
          content: match[2]
        })
        lastIndex = pattern.lastIndex
      }
      parts.push({
        isClickable: false,
        text: text.substring(lastIndex),
        content: null
      })
      return parts
    },
    previousQuestion () {
      this.showAnswer = false
      if (!this.previousQuestionEnable) return
      this.saveQuestion(this.question.index - 1, true)
    },
    showImage (image) {
      this.$viewerApi({
        images: [image]
      })
    },
    saveQuestion (next = null, time = false) {
      if (!this.question.loaded) return

      this.checkQuestionComplete()

      const data = {
        index: this.question.index,
        meta: this.question.data.meta,
        completed: this.question.completed,
        flagged: this.question.flagged
      }

      if (time) {
        this.question.loaded = false
        data.time_spent_solving = this.getSeconds(this.stopwatch.question.solving)
        data.time_spent_full = this.getSeconds(this.stopwatch.question.full)
      }

      this.$http
        .post(`app/testprep/${this.quizId}/question`, data)
        .then((response) => {
          if (response.status === 200) {
            this.question.info = response.data.data.info
            if (next !== null) this.fetchQuestion(next)
          }
        })
        .catch(() => {})
    },
    summaryQuestionBackground (item, type) {
      if (!this.complete.active && item.question_id === this.question.data.id) {
        return '#0059ff'
      }
      if (type === 'complete') {
        if (item.correct) return '#0cdc62'
        if (!item.completed) return '#0059ff'
        return '#fd4445'
      }
      if (type === 'popup') {
        if (item.flagged) return '#fd4445'
        if (item.completed) return '#0cdc62'
        if (item.viewed) return '#FF9F43'
      }
      return 'transparent'
    },
    summaryCompleteQuestion (index) {
      this.complete.summary = false
      this.fetchQuestion(index)
      setTimeout(() => {
        this.complete.question = true
      }, 350)
    },
    summaryCompleteShow () {
      this.complete.question = false
      setTimeout(() => {
        this.fetchSummary('complete')
      }, 350)
    },
    stopwatchStart () {
      this.stopwatch.display = useStopwatch(true)
    },
    confirmSubmitQuiz () {
      this.saveQuestion(null, true)
      this.appReady = false
      this.complete.active = true
      this.$http
        .post(`app/testprep/${this.quizId}/submit`)
        .then((response) => {
          if (response.status === 200) {
            if (this.timer.display) this.timer.display.pause()
            if (this.stopwatch.display) this.stopwatch.display.pause()
            this.fetchReport()
          }
        })
        .catch(() => {})
    },
    submitQuiz () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Are You Ready To Submit?',
        text: 'Please make sure you review all questions before submitting. ',
        accept: this.confirmSubmitQuiz,
        acceptText: 'Submit Quiz'
      })
    },
    timerEnd () {
      this.timer.display = null
    },
    timerStart (ts) {
      const time = new Date(ts)
      this.timer.display = useTimer(time)
    },
    visualChange (type) {
      if (type === 'Reset') {
        document.querySelectorAll('.TpVisualChange').forEach((span) => {
          span.style.color = null
          span.style.backgroundColor = null
          span.style.textDecoration = null
        })
        this.visualChangeActive = false
        return
      }

      const range = window.getSelection().getRangeAt(0)
      if (!range || !range.commonAncestorContainer) return
      console.dir(range.commonAncestorContainer.parentNode)
      console.dir(range.commonAncestorContainer.parentNode)

      if (range.commonAncestorContainer.parentNode.parentNode.className === undefined) return
      if (
        !range.commonAncestorContainer.parentNode.parentNode.className.includes('TpAllowSelect') &&
        !range.commonAncestorContainer.parentNode.className.includes('TpAllowSelect') &&
        !range.commonAncestorContainer.parentNode.className.includes('TpVisualChange')
      ) return

      const span = document.createElement('span')

      if (type === 'Highlight') {
        span.style.color = '#000000'
        span.style.backgroundColor = '#fc0'
      }

      if (type === 'Strikethrough') {
        span.style.textDecoration = 'line-through'
        span.style.color = '#b7b7b7'
      }

      span.classList.add('TpVisualChange')
      span.appendChild(range.extractContents())
      range.insertNode(span)
      this.visualChangeActive = true

      window.getSelection().removeAllRanges()
    }
  },
  onIdle () {
    if (!this.stopwatch.question) return
    this.stopwatch.question.solving.pause()
    console.log('User Idle')
  },
  onActive () {
    if (!this.stopwatch.question) return
    this.stopwatch.question.solving.start()
    console.log('User Back')
  },
  mounted () {
    this.testPrepCompletedSound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Success.mp3')
    window.testPrepCompletedSound = this.testPrepCompletedSound

    this.wasSidebarOpen = this.$store.state.reduceButton
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)

    if (localStorage.getItem('testPrepSettings')) {
      const settings = JSON.parse(localStorage.getItem('testPrepSettings'))
      Object.keys(this.settings).forEach((key) => {
        if (settings[key]) this.settings[key] = settings[key]
      })
    }

    window.addEventListener('keydown', this.keyPressed)

    this.quizId = this.$route.params.quizId
    this.fetchInit()
  },
  beforeDestroy () {
    this.saveQuestion(null, true)
    if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
    window.addEventListener('keydown', this.keyPressed)
  }
}
</script>
<style lang="scss">
.theme-dusk {
  #TestPrepRenderer {
    input.vs-inputx.vs-input--input {
      background: #050056 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }

    .input-bg {
      background: #050056 !important;
    }

    .vs-con-textarea .vs-textarea {
      background: #050056 !important;
    }

    .vs-select--input {
      background: #050056 !important;
    }
  }
}

.theme-dark {
  #TestPrepRenderer {
    input.vs-inputx.vs-input--input {
      background: #1b1e22 !important;
      border: 1px solid #ffffff !important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary), 1) !important;
      }
    }

    .input-bg {
      background: #1b1e22 !important;
    }

    .vs-con-textarea .vs-textarea {
      background: #1b1e22 !important;
    }

    .vs-select--input {
      background: #1b1e22 !important;
    }
  }
}

#TestPrepRenderer {
  cursor: url('~@/assets/images/cursor/cursor-auto.png'), auto;

  .cursor-pointer {
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto !important;
  }

  button {
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto;
  }

  .TpProgressBar {
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 999999;
  }

  .TpAppScreen {
    min-height: 77.5vh;
  }

  .TpAppParent {
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    position: initial;
  }

  .TpBlockSelect {
    user-select: none !important;
  }

  .TpAppContainer {
    position: relative;
    padding: 0 10rem 0 10rem;
    width: 100%;
    min-height: 65vh;
    @media screen and (max-width: 1950px) {
      max-width: 1650px;
      padding: 0 3rem 0 3rem;
    }
  }

  .promptText {
    font-size: 34px;
    font-weight: bold;
  }

  .multiChoiceCard {
    width: fit-content;
    border: solid #e5e5e5;
    border-width: 1px 1px 1px 1px;
    transition: none;

    &:hover {
      background: rgba(0, 0, 0, 0.15);
    }

    &:active {
      transform: translateY(2px) translateZ(0);
    }

    &.cardSelected {
      background: rgba(24, 153, 214, 0.8);
      border-color: #84d8ff;
    }

    &.cardSuccess {
      background: rgb(12, 220, 98, 0.8);
      border-color: #00ff48;
    }

    &.cardDanger {
      background: rgba(253, 68, 69, 0.8);
      border-color: #ff191b;
    }

    &.cardWarning {
      background: rgba(255, 159, 67, 0.8);
      border-color: #ff8811;
    }

    .vx-card__body {
      height: 100%;
      padding: 0.65rem;
    }

    .vx-card__collapsible-content.vs-con-loading__container {
      height: 100%;
    }
  }
}
</style>
